import { routerReducer } from "@ngrx/router-store";
import { ActionReducerMap } from "@ngrx/store";
import { FormState, formStateFeatureKey, formStateReducer } from "./form";
import { RouterState, routerStateFeatureKey } from "./router-reducers";
import { StatusState, statusStateFeatureKey, statusStateReducer } from "./status";
import { StepsValidityState, stepsValidityStateFeaturekey, stepsValidityStateReducer } from "./step-validity";

export interface State {
  [routerStateFeatureKey]: RouterState,
  [stepsValidityStateFeaturekey]: StepsValidityState,
  [formStateFeatureKey]: FormState,
  [statusStateFeatureKey]: StatusState
}

export const reducers: ActionReducerMap<State> = {
  [routerStateFeatureKey]: routerReducer,
  [stepsValidityStateFeaturekey]: stepsValidityStateReducer,
  [formStateFeatureKey]: formStateReducer,
  [statusStateFeatureKey]: statusStateReducer
}